import * as React from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import type { GenericList } from './models/JobSharedInterfaces';
import * as DateHelpers from './DateHelpers';
import { CheckPermissions, DownloadFile, GetQuery } from './Shared';

const ReportItemsOnHireByDateData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [branchOptions, setBranchOptions] = React.useState<GenericList[]>([]);
    const [customers, setCustomers] = React.useState<GenericList[]>([]);
    const [reportDate, setReportDate] = React.useState("");
    const [branchId, setBranchId] = React.useState(-1);
    const [customerId, setCustomerId] = React.useState(-1);

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("RunItemsOnHireReports");
        if (hasPermission) {
            getBranchCustomers();
        } else {
            navigate("/accessdenied")
        }
    }

    const getBranchCustomers = async () => {
        const apiUrl = "GetReportBranchCustomers";
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setBranchOptions(result.data.branches);
            setCustomers(result.data.customers);
            setLoading(false);
        }
    }

    const clearError = (e: any) => {
        var error = errors;
        delete error[e.target.name];
        setErrors(error);
    }

    const handleDateChange = (e: any) => {
        clearError(e);

        setReportDate(e.target.value);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (!reportDate) {
            formIsValid = false;
            errorList["reportDate"] = "Date is required";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data
        if (validate()) {
            runRpt();
        }
    }
 
    const runRpt = async () => {
        var rptDateFileName = DateHelpers.formatDateToUS(reportDate);
        var filename = "Items On Hire By Date " + rptDateFileName + ".xlsx";

        const apiUrl = 'RunItemsOnHireByDateReport?reportDate=' + reportDate + '&branchId=' + branchId + '&CustomerId=' + customerId;
        await DownloadFile(apiUrl, filename);
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Items On Hire / Scheduled By Date Report</h1>
                <div>This report will show all jobs installed on site or scheduled to to be installed on site up until and including the date selected</div>
                <div>It will exclude any jobs that will be fully picked up until and including the date selected</div>
            </div>
            <div>
                <label className="input-group" htmlFor="reportDate">
                    <span className="label">Date</span>
                    <input type='date' id="reportDate" name="reportDate" className='input' value={reportDate} onChange={(e) => handleDateChange(e)}></input>
                </label>
                <span className={errors["reportDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["reportDate"]}</span>

                <label className="input-group" htmlFor="branchId">
                    <span className="label">Branch</span>
                    <select className="select" id="branchId" name="branchId" value={branchId} onChange={(e) => setBranchId(Number(e.target.value))}>
                        <option defaultValue="-1" value="-1"></option>
                        {branchOptions.map(branch =>
                            <option key={branch.id} value={branch.id}>{branch.name}</option>
                        )};
                    </select>
                </label>

                <label className="input-group" htmlFor="customerId">
                    <span className="label">Customer</span>
                    <select className="select" id="customerId" name="customerId" value={customerId} onChange={(e) => setCustomerId(Number(e.target.value))}>
                        <option defaultValue="-1" value="-1"></option>
                        {customers.map(cust =>
                            <option key={cust.id} value={cust.id}>{cust.name}</option>
                        )};
                    </select>
                </label>
            </div>
            <div>
                <button className="defaultbutton marginLeftLabel" type='button' onClick={runReport}>Run Report</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    )

};

export default ReportItemsOnHireByDateData;